import React from 'react';
import {
  FdrCo2Emission,
  FdrImage,
  FdrLink,
  FdrLinkOpenMethod,
  FdrPrice,
  FdrProductFeatureGroup,
  FdrProductTravelType,
} from '@hotelplan/supergraph-api';

export type TFdrTARatingType = {
  rating: number | null;
  reviews?: number | null;
};

export type TFdrProductTypeData = {
  icon: string;
  title: string;
};

export type TFdrTravelersData = { adults: number; children: number };

export interface IFdrProductCardProps extends React.PropsWithChildren<{}> {
  publicId?: string | null;
  className?: string;
  productTravelType?: TFdrProductTypeData[];
  disrupter?: string | null;
  image?:
    | Omit<FdrImage, 'id'>
    | { images?: Omit<FdrImage, 'id'>[]; pagination: { total: number } };
  rating?: number | null;
  ta?: TFdrTARatingType;
  title?: React.ReactNode | null;
  subTitle?: React.ReactNode | null;
  closeButton?: React.ReactNode | null;
  header?: React.ReactNode | null;
  footer?: React.ReactNode | null;
  productFeatures?: FdrProductFeatureGroup[] | null;
  link?: FdrLink;
  onClick?: (e?: React.MouseEvent) => void;
  price?: FdrPrice | null;
  priceTotal?: FdrPrice | null;
  testId?: string;
  pointOfInterests?: string;
  editButton?: boolean;
  distanceInfo?: number;
  productType?: TFdrProductType;
  transferPrice?: FdrPrice | null;
  transferIncluded?: boolean;
  travelers?: TFdrTravelersData;
  travelType?: FdrProductTravelType;
  isSingle?: boolean;
  openMethod?: FdrLinkOpenMethod;
  co2Emission?: FdrCo2Emission;
}

export type TFdrProductType =
  | 'FdrCruise'
  | 'FdrHotel'
  | 'FdrRoundTrip'
  | 'FdrApartment'
  | 'FdrAdventureTravel';

export enum EFdrProductType {
  Apartment = 'FdrApartment',
  Cruise = 'FdrCruise',
  Hotel = 'FdrHotel',
  Roundtrip = 'FdrRoundTrip',
}
